export default __webpack_public_path__ + "static/media/loading.23863143.png";